export const PINK_ANGLE_COLORS = [0xFC99C4, 0xF94F6F];
export const CENTER_OF_CIRCLE = { x: 600, y: 310 };
export const CIRCLE_RADIUS = 200;
export const INITIAL_RADIANS = [Math.PI / 2];
export const ARC_COLOR_ARR = [0x000000, 0x000000];
export const INFO_SLIDER_COORD = { x: 1180, y: 200 };
export const SLIDERS_COORD = [{ x: 460, y: 800 }];
export const SLIDERS_COORD_OFFSET_VERTICAL = [{ x: 100, y: 420 }];
export const TANGENT_TYPE_CON_COORD = { x: 100, y: 780 };
export const TANGENT_TYPE_CON_OFFSET_VERTICAL = { x: -330, y: 400 }
export const INFO_SLIDER_ASSETS_SLUG = "circle-theorem-6";
